import { IIconBandSetting } from "Bands/types";
import { Question } from "shared/assets/icons";
import { getIcon } from "shared/utils";

export const getEventTypeIcon = (
  type?: string | IIconBandSetting,
  eventTypes?: IIconBandSetting[]
) => {
  let icon;
  if (typeof type === "string") {
    icon = eventTypes?.find(({ id }) => id === type)?.icon;
  } else {
    icon = type?.icon;
  }
  return icon ? getIcon(icon) : Question;
};
